import vConnect from './vConnect'
import login from './login'
import logout from './logout'
import v from './v'
import createClient from './createClient'
import changes from './changes'
import method from './method'

export default {
  vConnect,
  login,
  logout,
  v,
  createClient,
  changes,
  method
}



// WEBPACK FOOTER //
// ./src/data/api/accessing_vconnect/index.js